import React from 'react';
import Moment from 'moment';
import { extendMoment } from 'moment-range';

// mui
import { Grid, Container, Typography } from '@mui/material';

// collections
import JobDaysForDate from './collections/JobDaysForDate/JobDaysForDate.collection';

const moment = extendMoment(Moment);

export default function Schedule() {

    const today = moment()
    const startDate = today.clone().subtract('30', 'days')  // 30 days back
    const endDate = today.clone().add('60', 'days')         // 60 days forward
    const daterange = moment.range(startDate, endDate)

    let dates = []

    // for (let day of daterange.by('days')) {
    //     dates.push(day.format("YYYY-MM-DD"))
    // }
    dates = Array.from(daterange.reverseBy('days')).map(day => day.format("YYYY-MM-DD"))
    
    return (<div>
        <Container disableGutters sx={{ marginBottom: 4}}>
            <Grid container justifyContent="center">
                <Grid item><Typography variant="h2">My Schedule</Typography></Grid>
            </Grid>
        </Container>

        {
            dates.map(date => {
                return (<JobDaysForDate date={date} />)
            })
        }

    </div>)
}